class sectionVideoCarousel extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      carousel: '[js-carousel]',
    }
  }

  connectedCallback() {
    this.carousel = this.querySelector(this.selectors.carousel);
    this.initCarousel();
  }

  initCarousel() {
    var slider = tns({
      container: this.carousel,
      items: 1,
      gutter: 14,
      center: true,
      nav: false,
      controls: false,
      mouseDrag: true,
      swipeAngle: false,
      speed: 500,
      responsive: {
        "1024":{
          items: 2,
          gutter: 30
        }
      }
    });

    slider.events.on('transitionEnd', this._pauseVideo.bind(this));
  }

  _pauseVideo = (evt) => {
    var videos = this.querySelectorAll('video');
    videos.forEach((video) => {
      video.load();
      video.controls = false;
    })

    if (window.innerWidth >= 1024) {
      var currentSlide = this.carousel.querySelector('.tns-item:not(.tns-slide-active) + .tns-slide-active + .tns-slide-active');
      currentSlide.querySelector('[js-play-pause-button-desktop]').setAttribute("aria-playing", "false");
    } else {
      var currentSlide = this.carousel.querySelector('.tns-item.tns-slide-active');
      currentSlide.querySelector('[js-play-pause-button-mobile]').setAttribute("aria-playing", "false");
    }
  }
}

customElements.define('section-video-carousel', sectionVideoCarousel)